interface FooterProps {
  city: string;
}

export function Footer({ city }: FooterProps) {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-teal rounded-xl flex items-center justify-center">
                <i className="ri-window-line text-white text-2xl"></i>
              </div>
              <div>
                <div className="font-bold text-xl">FenetrePro</div>
                <div className="text-xs text-teal">{city}</div>
              </div>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              Expert en réparation de fenêtres PVC, aluminium, bois et baies vitrées à {city} et sur tout le Bassin d'Arcachon.
            </p>
          </div>

          <div>
            <h3 className="font-bold text-lg mb-4">Services</h3>
            <ul className="space-y-3 text-sm">
              <li>
                <button onClick={() => scrollToSection('services')} className="text-gray-400 hover:text-teal transition-colors cursor-pointer">
                  Fenêtres PVC
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-gray-400 hover:text-teal transition-colors cursor-pointer">
                  Fenêtres Aluminium
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-gray-400 hover:text-teal transition-colors cursor-pointer">
                  Fenêtres Bois
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('baies-vitrees')} className="text-gray-400 hover:text-teal transition-colors cursor-pointer">
                  Baies Vitrées
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-bold text-lg mb-4">Contact</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-center gap-2 text-gray-400">
                <i className="ri-phone-line text-teal"></i>
                <a href="tel:+33554542545" className="hover:text-teal transition-colors cursor-pointer">05 54 54 25 45</a>
              </li>
              <li className="flex items-center gap-2 text-gray-400">
                <i className="ri-mail-line text-teal"></i>
                <a href="mailto:contact@fenetrepro-arcachon.fr" className="hover:text-teal transition-colors cursor-pointer">contact@fenetrepro-arcachon.fr</a>
              </li>
              <li className="flex items-center gap-2 text-gray-400">
                <i className="ri-map-pin-line text-teal"></i>
                <span>{city}, Gironde</span>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-bold text-lg mb-4">Horaires</h3>
            <ul className="space-y-3 text-sm text-gray-400">
              <li>Lundi - Vendredi : 8h - 19h</li>
              <li>Samedi : 9h - 17h</li>
              <li>Dimanche : Urgences uniquement</li>
              <li className="text-teal font-medium pt-2">Disponible 7j/7</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-400">
            <div>
              © 2025 FenetrePro {city}. Tous droits réservés.
            </div>
            <div className="flex items-center gap-6">
              <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="hover:text-teal transition-colors cursor-pointer">
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}